/*
Function is a temporary solution until the APP and WEB will handle markdown in the same way
*/

export function convertHighlightTagToMarkdown(text: string): string {
  return text.replace(/<highlight>(.*?)<\/highlight>/g, ':highlight[$1]');
}
